"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const partners = [{
  id: 1,
  name: "The Royal Hotel",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_royal_hotel.png",
  description: "Exclusive access to premium suites and personalized concierge services for our esteemed clients."
}, {
  id: 2,
  name: "Aero Private Jets",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_aero_jets.png",
  description: "Seamless global travel with priority booking and complimentary upgrades on all chartered flights."
}, {
  id: 3,
  name: "Maison Gastronomique",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_maison_gastro.png",
  description: "Curated culinary experiences and guaranteed reservations at Michelin-starred establishments."
}, {
  id: 4,
  name: "Luxe Yacht Charters",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_luxe_yachts.png",
  description: "Bespoke maritime journeys with dedicated crew and customized itineraries across the Mediterranean."
}, {
  id: 5,
  name: "Elite Spa Retreats",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_elite_spa.png",
  description: "Rejuvenating wellness packages and priority access to world-renowned holistic sanctuaries."
}, {
  id: 6,
  name: "Vanguard Motors",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_vanguard_motors.png",
  description: "Chauffeur-driven luxury vehicles available on-demand for seamless ground transportation."
}];
export default function SignaturePartnerships() {
  return <section id="signature-partnerships" className="py-24 bg-background overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="h-px w-full bg-gradient-to-r from-transparent via-secondary to-transparent mb-16 opacity-60" />

        <div className="text-center mb-12">
          <h2 className="font-default text-3xl md:text-4xl text-foreground font-medium tracking-wide mb-4">
            Signature Partnerships
          </h2>
          <p className="font-default text-muted-foreground text-lg max-w-2xl mx-auto">
            Collaborating with the world's most distinguished purveyors of luxury to elevate your experience.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full max-w-6xl mx-auto">
          <CarouselContent className="-ml-4 md:-ml-6">
            {partners.map((partner, i) => <CarouselItem key={partner.id} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3 xl:basis-1/4">
                <div className="group relative h-56 flex items-center justify-center rounded-lg border border-border/40 bg-card/20 overflow-hidden transition-all duration-800 ease-in-out hover:border-secondary/40 hover:shadow-lg hover:shadow-secondary/5">
                  {}
                  <img src={partner.logo} alt={partner.name} className="max-w-[140px] max-h-[70px] object-contain grayscale opacity-50 transition-all duration-800 ease-in-out group-hover:opacity-0 group-hover:scale-95" />

                  {}
                  <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center opacity-0 backdrop-blur-md bg-background/85 transition-all duration-800 ease-in-out group-hover:opacity-100">
                    <h3 className="font-default text-secondary text-xl font-medium mb-3 tracking-wide transform translate-y-4 transition-transform duration-800 ease-in-out group-hover:translate-y-0">
                      {partner.name}
                    </h3>
                    <p className="font-default text-foreground/90 text-sm leading-relaxed transform translate-y-4 transition-transform duration-800 ease-in-out delay-75 group-hover:translate-y-0">
                      {partner.description}
                    </p>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="flex items-center justify-center gap-6 mt-16">
            <CarouselPrevious className="static translate-y-0 translate-x-0 size-12 border-border/50 hover:bg-secondary hover:text-secondary-foreground hover:border-secondary transition-all duration-500" />
            <CarouselNext className="static translate-y-0 translate-x-0 size-12 border-border/50 hover:bg-secondary hover:text-secondary-foreground hover:border-secondary transition-all duration-500" />
          </div>
        </Carousel>
      </div>
    </section>;
}